import { Component } from "react";
import { connect } from "react-redux";
import { AUlinkList, AUmainNav, AUmainNavContent } from "../ui";
import { withRouter, RouteComponentProps, NavLink } from "react-router-dom";
import { Path } from "./Routes/Routes";
import { StoreState } from "../store";
import { routeStatus } from "../util/helperFunctions";
import "./Nav.css";
const mapStateToProps = (state: StoreState) => routeStatus(state);

class NavComponent extends Component<RouteComponentProps> {
  render() {
    const currentRoute = this.props.location.pathname;

    const mainLinks = [
      {
        link: Path.Introduction,
        text: "Introduction",
        active:
          currentRoute === Path.Introduction || currentRoute === Path.Root
            ? true
            : undefined
      },
      {
        link: Path.FarmDetails,
        text: "Farm details",
        active: currentRoute === Path.FarmDetails ? true : undefined
      },
      {
        link: Path.MethodDiscovery,
        text: "Method discovery",
        active: currentRoute === Path.MethodDiscovery ? true : undefined
      }
    ];

    const subMenuLinks = [
      {
        link: Path.NextSteps,
        text: "Next Steps",
        active: currentRoute === Path.NextSteps ? true : undefined
      },
      {
        link: Path.About,
        text: "About",
        active: currentRoute === Path.About ? true : undefined
      }
    ];

    return (
      <AUmainNav className="Nav">
        <div className="container">
          <div className="row">
            {/* Note this requires react-router-dom@5.0.1 due to https://github.com/govau/design-system-components/issues/892 */}
            <AUmainNavContent linkComponent={NavLink} items={mainLinks}>
              <AUlinkList linkComponent={NavLink as any} items={subMenuLinks} />
            </AUmainNavContent>
          </div>
        </div>
      </AUmainNav>
    );
  }
}

export default withRouter(connect(mapStateToProps)(NavComponent));
